<div class="tree-container">
  <div class="buttons">
    <button
      nbTooltip="Collapse all"
      nbButton
      fullWidth
      (click)="collapseAll()"
      [disabled]="showLoadingSpinner"
    >
      <fa-icon [icon]="faCompressArrowsAlt"></fa-icon>
    </button>
    <button
      nbTooltip="Expand once"
      nbButton
      fullWidth
      (click)="expandOnce()"
      [disabled]="showLoadingSpinner"
    >
      <fa-icon [icon]="faExpandArrowsAlt"></fa-icon>
    </button>
    <ng-container
      *ngxNbRoleHide="['update', Permissions.assetTreeUpdate]"
      class="w-100"
    >
      <button
        *ngIf="(editMode$ | async) !== true && editable"
        nbTooltip="Edit tree"
        nbButton
        fullWidth
        (click)="edit()"
        [disabled]="showLoadingSpinner"
      >
        <fa-icon [icon]="faEdit"></fa-icon>
      </button>
    </ng-container>
    <button
      *ngIf="editMode$ | async"
      nbTooltip="Save changes"
      nbButton
      fullWidth
      status="primary"
      (click)="save()"
      [disabled]="showLoadingSpinner"
    >
      <fa-icon [icon]="faSave"></fa-icon>
    </button>
    <button
      *ngIf="editMode$ | async"
      nbTooltip="Discard changes"
      nbButton
      fullWidth
      status="danger"
      (click)="cancel()"
      [disabled]="showLoadingSpinner"
    >
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>

  <p-tree
    #assettree
    selectionMode="single"
    scrollHeight="flex"
    [value]="treeNodes$ | async"
    [loading]="showLoadingSpinner"
    [selection]="selectedNode"
    [filter]="true"
    [contextMenu]="useContextMenu ? contextMenu.contextMenu : null"
    [draggableNodes]="true"
    [droppableNodes]="true"
    draggableScope="self"
    droppableScope="self"
    (onNodeSelect)="onNodeSelected($event.node)"
    (onNodeContextMenuSelect)="contextMenu.setMenuItems($event.node.data)"
  ></p-tree>
</div>

<ngx-asset-tree-context-menu #contextMenu></ngx-asset-tree-context-menu>
